import React, { FC } from 'react';

export const Loader: FC = () => {
  return (
    <div className='loader'>
      <p>Loading...</p>
    </div>
  );
};
